<template>
    <div class="page-wrapper">
        <keep-alive>
            <router-view :key="$route.fullPath"></router-view>
        </keep-alive>
    </div>
</template>
<script>
export default {
    name: 'MissionAlive',
    data: function () {
        return {
            //isHaveMenu: false
        }
    },
    // watch: {
    //     $route(to) {
    //         this.setPageClass(to);
    //     }
    // },
    methods: {
        // setPageClass: function (to) {
        //     this.isHaveMenu = (to.name == "reward list");
        // }
    },
}
</script>
